/**
 * Autopromo slider
 */
(function($) {
    "use strict";

    $(window).ready(slickify);

    // Constants
    var blocAutopromo = ".field--name-field-autopromo";
    /**
     * Init
     */
    function slickify() {
        $(blocAutopromo).not('.slick-initialized').slick({
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000
        });
    }

    $(window).resize(function(){
        var $windowWidth = $(window).width();
        if ($windowWidth > 300) {
            slickify();
        }
    });

})(jQuery);
